import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getActionFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`fields.Title`),
      columnHeader: t(`actions.columns.title`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`fields.Description`),
      columnHeader: t(`actions.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`fields.Status`),
      columnHeader: t(`actions.columns.status`),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'action_status' },
    },
    DateRaised: {
      fieldId: 'DateRaised',
      formLabel: t(`actions.fields.DateRaised`),
      columnHeader: t(`actions.columns.date_raised`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    DateDue: {
      fieldId: 'DateDue',
      formLabel: t(`actions.fields.TargetCloseDate`),
      columnHeader: t(`actions.columns.due_date`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    ClosedDate: {
      fieldId: 'ClosedDate',
      formLabel: t(`actions.fields.ClosedDate`),
      columnHeader: t(`actions.columns.closed_date`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    Priority: {
      fieldId: 'Priority',
      formLabel: t(`actions.fields.Priority`),
      columnHeader: t(`actions.columns.priority`),
      displayType: { displayType: 'rating', ratingKey: 'priority' },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
